import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/login', name: 'login', component: () => import('@/views/login/login.vue'), meta: { title: '登录' } },
  { path: '/loading', name: 'loading', component: () => import('@/views/loadingPage/loadingPage.vue'), meta: { title: '加载中' } },
  { path: '/project-select', name: 'project-select', component: () => import('@/views/projectSelect/projectSelect.vue'), meta: { title: '选择项目' } },
  { path: '/403', name: '403', component: () => import('@/views/error/403.vue'), meta: { title: '无权限' } },
  { path: '/404', name: '404', component: () => import('@/views/error/404.vue'), meta: { title: '页面不存在' } },
  {
    path: '/',
    component: Layout,
    // 根路径 redirect 到 loading 中转页，由其按岗位跳转默认首页
    // （系统管理员→用户管理；项目管理员→模块管理）
    redirect: '/loading',
    children: [
      // 内容管理
      { path: 'model-manage/list', name: 'model-manage-list', component: () => import('@/views/modelManage/modelManage.vue'), meta: { title: '模块管理', icon: 'el-icon-files', parent: '内容管理' } },
      // 系统管理
      { path: 'auth-user/list', name: 'auth-user-list', component: () => import('@/views/authUser/authUser.vue'), meta: { title: '用户管理', icon: 'el-icon-user', parent: '系统管理' } },
      { path: 'auth-project/list', name: 'auth-project-list', component: () => import('@/views/authProject/authProject.vue'), meta: { title: '项目管理', icon: 'el-icon-office-building', parent: '系统管理' } }
    ]
  },
  { path: '*', redirect: '/404' }
]

const router = new VueRouter({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes
})

export default router
